mutation SetDefaultCountryAccess($id: ID!) {
  setDefaultCountryAccess(id: $id) {
    id
    isDefault
  }
}
